import { ROOT_ID, type MissingFieldHandler } from 'relay-runtime';

import { expVal } from '@confluence/feature-experiments';

/** Reuse individually normalized onboarding states when a consumer requests a new key subset. */
export const onboardingStateMissingFieldHandler: MissingFieldHandler = {
	kind: 'pluralLinked',
	handle(field, record, args, store) {
		if (
			record?.getDataID() !== ROOT_ID ||
			field.name !== 'onboardingState' ||
			!expVal('confluence_pgxp_p2m_batch_1', 'isEnabled', false)
		) {
			return undefined;
		}

		const keys: unknown[] = Array.isArray(args.key) ? args.key : [args.key];
		const ids: string[] = [];
		for (const key of keys) {
			// Match getConfluenceDataID; never fabricate nulls for uncached or invalid keys.
			if (typeof key !== 'string' || store.get(key)?.getType() !== 'OnboardingState') {
				return undefined;
			}
			ids.push(key);
		}

		// Relay checks selected fields on these records, including missing vs. explicit null values.
		return ids;
	},
};
